import AbstractToolCollection from "../AbstractToolCollection";
import HelpTool from "../HelpTool";
import SelectTool from "./SelectTool";
import SettingsTool from "./SettingsTool";

export default class ToolCollection extends AbstractToolCollection {
    constructor(provider) {
        super(provider);

        this.tools = {
            'select': new SelectTool(this.provider),
            'settings': new SettingsTool(this.provider),
            'help': new HelpTool(this.provider, 'view'),
        };
    }

    init() {
        this.tools['settings'].setButton(window['settingsButton']);
        this.tools['help'].setButton(window['helpButton']);

        this.currentTool = this.tools['select'];
        this.currentTool.activate();
    }
}
